import type { RouterConfig } from 'nuxt/schema'

export default {
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) return { el: to.hash }
        // 'instant': html { scroll-behavior: smooth } reaches the window scroll at every tier,
        // and a route change should land, not glide.
        if (savedPosition) return { ...savedPosition, behavior: 'instant' }
        else return { left: 0, top: 0, behavior: 'instant' }
    },
} satisfies RouterConfig
